import React from "react";
import { Link } from "react-router-dom";
import { Icons } from "../../../components/ui/icons";

const ACTIONS = [
  { href: "/add-activity", label: "New movement", icon: Icons.Plus },
  { href: "/create-quotation", label: "New quote", icon: Icons.Quotes },
  { href: "/reminders", label: "Reminders", icon: Icons.Bell },
  { href: "/reporting", label: "Reports", icon: Icons.Reporting },
];

const QuickActions: React.FC = () => (
  <div className="grid grid-cols-4 gap-2">
    {ACTIONS.map((action) => (
      <Link
        key={action.href}
        to={action.href}
        className="flex flex-col items-center gap-2 transition-transform active:scale-95 [-webkit-tap-highlight-color:transparent]"
      >
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl border border-gray-100 bg-white text-primary-600 shadow-[0_1px_3px_rgba(13,14,19,0.06)]">
          <action.icon width={24} height={24} />
        </span>
        <span className="text-center text-[11px] font-medium leading-tight text-gray-700">
          {action.label}
        </span>
      </Link>
    ))}
  </div>
);

export default QuickActions;
